<div class="bp-modal mod-lg">
  <bp-modal-header
    title="{{ (data.currentAntiPhishingCode ? 'anti_phishing_screen_update_title' : 'anti_phishing_screen_title') | translate }}">
    @if (!data.preventDismiss) {
      <a right (click)="closeAll()" (keydown.enter)="closeAll()" [tabIndex]="0">
        <strong>{{ "close" | translate }}</strong>
      </a>
    }
    @if (currentStep === 2) {
      <a
        left
        (click)="onClickBack()"
        (keydown.enter)="onClickBack()"
        [tabIndex]="0">
        <strong>{{ "back" | translate }}</strong>
      </a>
    }
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="bp-modal-body-section mod-wide pt-25 min-h-400">
      <!-- Step 1 - Enter Code -->
      @if (currentStep === 1) {
        <div class="extra-padding">
          @if (data.currentAntiPhishingCode === '') {
            <div class="text-center">
              <h2>{{ "anti_phishing_screen_header_title" | translate }}</h2>
              <p>{{ "anti_phishing_screen_header_description" | translate }}</p>
            </div>
          }
          <div class="modal-form" [formGroup]="antiPhishingFormGroup">
            <div
              class="form-group mb-0"
						[ngClass]="{
							'has-error': antiPhishingFormGroup.dirty && antiPhishingFormGroup.invalid
						}">
              @if (data.currentAntiPhishingCode !== '') {
                <div class="mt-20">
                  <div class="current-code__label">
                    {{ "anti_phishing_screen_your_current_code" | translate }}
                  </div>
                  <div class="current-code__value">
                    {{ dotify(data.currentAntiPhishingCode) }}
                  </div>
                  <div class="current-code__form-label mb-5 mt-20">
                    {{ "anti_phishing_screen_enter_new_code_label" | translate }}
                  </div>
                </div>
              }
              <input
                type="text"
                class="form-field"
                id="antiPhishingCode"
                formControlName="antiPhishingCode"
                autofocus
                (focus)="onApcInputFocused()"
                placeholder="{{ (data.currentAntiPhishingCode ? 'anti_phishing_screen_enter_new_code' : 'anti_phishing_screen_enter_code') | translate }}" />
              @if (antiPhishingFormGroup.dirty && antiPhishingFormGroup.invalid) {
                <div
                  class="form-error has-error align-left mt-10">
                  {{ "anti_phishing_screen_code_invalid_format_error" | translate }}
                </div>
              }
            </div>
            @if (!antiPhishingFormGroup.dirty || antiPhishingFormGroup.valid) {
              <ul
                class="validation-rule-list mt-10">
                <li class="validation-rule-list__item">{{ "anti_phishing_screen_code_requirement_one" | translate }}</li>
                <li class="validation-rule-list__item">{{ "anti_phishing_screen_code_requirement_two" | translate }}</li>
                <li class="validation-rule-list__item">{{ "anti_phishing_screen_code_requirement_three" | translate }}</li>
              </ul>
            }
            <div class="stay-safe mt-40">
              <h3 class="stay-safe__title">{{ "anti_phishing_screen_inline_notification_title" | translate }}</h3>
              <p class="stay-safe__description">{{ "anti_phishing_screen_inline_notification_description" | translate }}</p>
            </div>
          </div>
        </div>
      }
      <!-- Step 2 - SMS Verification -->
      @if (currentStep === 2) {
        <div class="extra-padding">
          @if ((has2fa$ | async)) {
            <two-fa (save)="on2FaSave($event)" [hasAutoValidation]="true" [isInputDisabled]="isSendingSmsCode"></two-fa>
          } @else {
            <div class="text-center" [formGroup]="smsCodeFormGroup">
              <!-- Subheader -->
              <div class="mt-20 mb-20 headline-base">{{ "verification_2fa_toggle_sms_modal_subheader" | translate }}</div>
              <!-- Subtext -->
              @if (profile$ | async; as profile) {
                <div class="mt-30 text-medium-black font-size-15">
                  {{ "enter_sms_code" | translate: [getUserPhone(profile)] }}
                </div>
              }
              <div class="mt-40 mb-40">
                <strong>
                  <a class="learn-more-link" href="javascript:void(null)" (click)="resendSmsCode()">{{ "send_waiting_resend_sms" | translate }}</a>
                </strong>
              </div>
              <input type="number" [attr.disabled]="isSendingSmsCode ? true : null" max="4" formControlName="smsCode"
                class="form-field sms-code-field" />
            </div>
          }
        </div>
      }
    </div>
    @if (currentStep === 1) {
      <div class="modal-footer-2fa">
        <div class="extra-padding">
          <button
            class="btn btn-primary confirm-button"
            (click)="verifyAntiPhishingCode()"
            [disabled]="antiPhishingFormGroup.invalid">
            <strong>
              {{ "confirm_title" | translate }}
            </strong>
          </button>
          @if (currentStep === 1) {
            <div class="text-center mt-20">
              <strong>
                <a (click)="learnMoreLinkClicked()" class="learn-more-link" href="https://support.bitpanda.com/hc/en-us/articles/15265986266780-Anti-phishing-codes-FAQ" target="_blank">{{ "anti_phishing_screen_learn_more" | translate }}</a>
              </strong>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
